import React from 'react';
import { i18n } from '@shared/util/i18n';
import { NestedOptionsRow } from '../NestedOptionsRow';
export function RelatedCardFilterRow() {
  return (
    <NestedOptionsRow
      name={i18n('common.filter')}
      defaultIcon={'filter-funnel'}
      selectedIcon="chat-bubbles-square"
      enabled={true}
    />
  );
}
